// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const happiny: PokeData = {
  "id": 440,
  "name": "happiny",
  "height": 6,
  "weight": 244,
  "base_experience": 110,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "tackle",
    "double-edge",
    "minimize",
    "defense-curl",
    "soft-boiled",
    "sweet-kiss",
    "charm",
    "refresh",
    "covet",
    "calm-mind",
    "copycat",
    "disarming-voice",
    "draining-kiss",
    "fairy-wind",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "sweet-kiss",
    "refresh",
    "calm-mind",
    "tri-attack",
    "quick-attack",
    "splash",
    "headbutt",
    "growl",
    "purification",
    "leer",
    "body-slam",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 51,
    "item": {
      "name": "luck-incense"
    },
    "species": [
      {
        "name": "happiny",
        "order": 126,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "chansey",
        "order": 127,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 440,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blissey",
        "order": 128,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 113,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 30,
    "ability_power": 15
  },
  "stat_changes": [],
  "catch_rate": 130,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
